module.exports = __webpack_public_path__ + "static/media/istanbul.21b85f80.jpg";